import React from "react";
import { Image } from "./image";

export const Gallery = (props) => {
  return (
    <div id="portfolio" className="text-center">
      <div className="container">
        <div className="section-title">
          <h2>Galería</h2>
          <p>
            Imágenes de nuestras actividades de capacitación, clases prácticas y servicios de asesoramiento para conductores.
          </p>
        </div>
        <div className="row">
          <div className="portfolio-items">
            {props.data
              ? props.data.map((d, i) => (
                  <div
                    key={`${d.title}-${i}`}
                    className="col-sm-6 col-md-4 col-lg-4"
                    style={{ marginBottom: "30px" }}
                  >
                    <Image
                      title={d.title}
                      largeImage={d.largeImage}
                    />
                  </div>
                ))
              : "Cargando..."}
          </div>
        </div>
      </div>
    </div>
  );
};
